export default __webpack_public_path__ + "static/media/BIMWindows.afaa2921.png";